import { Flex, Heading } from '@televet/kibble-ui';
import { Icon } from '@televet/kibble-ui/build/components/Icon';
import { Tooltip } from '@televet/kibble-ui/build/components/Tooltip';
import React from 'react';
import PetAvatar, { PetAvatarProps } from 'shared/components/Avatars/PetAvatar';
import { useSidePanelSearch } from 'shared/components/SidePanel/components/SearchPanel/state/providers/SearchPanelProvider';

export type PetParticipantItemProps = Pick<
  PetAvatarProps,
  'speciesType' | 'isDeceased' | 'id' | 'name' | 'isActive'
> & { isOrphan?: boolean };

const PetParticipantItem = (props: PetParticipantItemProps): JSX.Element => {
  const { viewClinicPet, setCurrentClinicPetParentId } = useSidePanelSearch();

  return (
    <Flex gap={2} alignItems="center">
      <PetAvatar
        color="white"
        size="sm"
        tooltipPlacement="top"
        isDeceased={props.isDeceased}
        speciesType={props.speciesType}
        name={props.name}
        isActive={props.isActive}
        hideRightMargin
        onClick={(): void => {
          setCurrentClinicPetParentId('');
          viewClinicPet({ clinicPetId: props.id || '', isPanelZIndexIncreased: true });
        }}
      />
      <Heading size="sm">{props.name}</Heading>
      {props.isOrphan && (
        <Tooltip label="This pet has no associated owners and will be removed from the conversation." placement="top">
          <Icon name="warningSign" size="xs" color="text.warning" />
        </Tooltip>
      )}
    </Flex>
  );
};

export default PetParticipantItem;
